import React, { ReactNode } from 'react';
import cx from 'classnames';

import { getAudioFileIcon, IconRightArrow } from '@trqk/components';

interface Props {
    children: ReactNode;
    gridTemplateColumns: string;
    index: number;
    rowsAboveTasks: number;
    filename: string;
}

export const TrackMatchingRow = ({
    children,
    gridTemplateColumns,
    index,
    rowsAboveTasks,
    filename,
}: Props): JSX.Element => {
    const subGridClass = cx('grid py-4', {
        'bg-highlight-palelavender': index % 2 !== 0,
    });
    const rowStart = rowsAboveTasks + index + 1;
    const rowEnd = rowStart + 1;

    const Icon = getAudioFileIcon(filename);

    return (
        <div
            className={subGridClass}
            style={{
                gridArea: `${rowStart} / 1 / ${rowEnd} / 8`,
                gridTemplateColumns,
                gridTemplateRows: 'auto',
            }}
        >
            <div
                style={{
                    gridArea: `1 / 3 / 2 / 4`,
                }}
                className="flex justify-start items-center"
            >
                <Icon fillColor="primary-500" />
                <div className="ml-2 text-sm">{filename}</div>
            </div>
            <div
                style={{
                    gridArea: `1 / 4 / 2 / 5`,
                }}
                className="flex justify-center items-center"
            >
                <IconRightArrow fillColor="tertiary-300" />
            </div>
            <div
                style={{
                    gridArea: `1 / 5 / 2 / 6`,
                }}
            >
                {children}
            </div>
        </div>
    );
};
